<script>
    import { keyScope } from '../scripts/keyboard';
    import ActionButton from './components/ActionButton.svelte';
    import CopyButton from '../CopyButton.svelte';
    import ApiClient from '../scripts/apiclient';
    import { createActionRunner } from '../scripts/ActionRunner';
    import PlaygroundHelper from '../scripts/playgroundhelper';

    const { busy, run } = createActionRunner();

    export let photoEdit;

    $: photo = photoEdit.photo;
    $: playground = photoEdit.playground;
    $: photoUrl = ApiClient.getThumbnailUrl(photo._id, 400) + '&q=' + new Date().getTime();

    export let closePopup;

    const approve = run(() => {
        return ApiClient.approvePhotoEdit(photoEdit).then(updated => {
            Object.assign(photoEdit, updated);
            close();
        });
    });

    const reject = run(() => {
        return ApiClient.rejectPhotoEdit(photoEdit).then(updated => {
            Object.assign(photoEdit, updated);
            close();
        });
    });

    function cancel() {
        close();
    }

    // Closing is possible while an action is running, so that a hanging action can be
    // abandoned and retried. The flag makes sure that an action finishing after that
    // doesn't close the popup a second time, closing whatever has been opened since.
    let closed = false;

    function close() {
        if (closed || !closePopup) {
            return;
        }

        closed = true;
        closePopup();
    }

    keyScope({ Enter: approve, Escape: cancel, a: reject }, { modal: true });
</script>

<h3>{PlaygroundHelper.presentPlayground(playground, false)}</h3>
<span class="subtitle"><i class="fas fa-map-marker" /> <span class="id-text">{playground._id}</span><CopyButton text={playground._id} title="Kopiera lekplatsens id" /></span>

<img src={photoUrl} width="400" height="400" alt="Foto av lekplatsen" />

<div class="button-wrapper">
    <button class="btn btn-sm" on:click={cancel}>Avbryt</button>
    <ActionButton {busy} action={reject} variant="btn-warning" title="Avslå förslaget"><u>A</u>vslå</ActionButton>
    <ActionButton {busy} action={approve} variant="btn-danger" title="Godkänn borttagning">Ta bort foto</ActionButton>
</div>

<style>
    h3 {
        margin-bottom: 0;
    }

    .subtitle {
        display: block;
        color: #444;
        padding: 0;
        margin: 0;
    }

    .button-wrapper {
        margin-top: 15px;
        text-align: right;
    }
</style>
